(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tycap-memory"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('tycap-memory')) {
    class TycapMemoryServer {
      constructor(root) {
        this.root = root;
        this.text = root.dataset;
        this.storageKey = 'tycap-memory-server-v2';
        this.cards = Array.from(root.querySelectorAll('[data-card]'));
        this.symbols = Array.from(root.querySelectorAll('template[data-symbol]'));
        this.start = root.querySelector('[data-start]');
        this.retry = root.querySelector('[data-retry]');
        this.status = root.querySelector('[data-status]');
        this.state = null;
        this.busy = false;
        this.failed = false;
        this.controller = new AbortController();
      }
      day() {
        return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      }
      cached() {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (entry.version !== 2 || !/^[a-f0-9]{64}$/.test(entry.visitorToken || '')) throw new Error('Invalid identity');
        return entry;
      }
      async identity() {
        const obtain = () => {
          const cached = this.cached();
          if (cached) return cached.visitorToken;
          const bytes = crypto.getRandomValues(new Uint8Array(32));
          const visitorToken = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
          localStorage.setItem(this.storageKey, JSON.stringify({ version: 2, visitorToken }));
          return visitorToken;
        };
        return navigator.locks?.request ? navigator.locks.request(this.storageKey, obtain) : obtain();
      }
      connect() {
        try {
          const url = new URL(this.text.endpoint);
          if (url.protocol !== 'https:' || url.host !== 'tycaptcg.app.n8n.cloud' || url.pathname !== '/webhook/tycap-memory-v2' || url.username || url.password || url.search || url.hash) throw new Error('Invalid endpoint');
          this.endpoint = url.href;
          const saved = this.cached();
          this.token = saved?.visitorToken;
          const signal = this.controller.signal;
          this.root.addEventListener('click', event => {
            if (event.target.closest('[data-start]')) this.send('start');
            if (event.target.closest('[data-retry]')) this.send(this.state?.status === 'won' ? 'claim' : 'state');
            const card = event.target.closest('[data-card]');
            if (card && this.root.contains(card)) this.send('flip', this.cards.indexOf(card));
          }, { signal });
          window.addEventListener('storage', event => {
            if (event.key !== this.storageKey || !event.newValue || this.busy) return;
            try {
              const updated = JSON.parse(event.newValue);
              if (updated.visitorToken === this.token && (updated.day !== this.state?.day || updated.revision !== this.state?.revision)) this.send('state');
            } catch { this.showFailure(); }
          }, { signal });
          this.clockDay = this.day();
          this.dayTimer = window.setInterval(() => {
            const current = this.day();
            if (current !== this.clockDay && !this.busy) {
              this.clockDay = current;
              if (this.token) this.send('state');
            }
          }, 60000);
          this.render();
          if (saved?.day === this.clockDay) this.send('state');
        } catch {
          this.start.disabled = true;
          this.status.textContent = this.text.blocked;
          this.root.querySelector('[data-button-label]').textContent = this.text.blockedLabel;
        }
      }
      disconnect() {
        this.controller.abort();
        this.requestController?.abort();
        window.clearTimeout(this.turnTimer);
        window.clearInterval(this.dayTimer);
      }
      parse(body, status) {
        if (!body || body.ok !== true || !/^\d{4}-\d{2}-\d{2}$/.test(body.day || '') || !Number.isInteger(body.revision) || body.revision < 0 || !Number.isFinite(body.serverTime)) throw new Error('Invalid response');
        if (body.status === 'idle' && status === 200) return { ...body, cards: Array(8).fill(null), matched: [], open: [], errors: 0, turns: 0, closeAt: 0, reward: null };
        if (![200, 409, 503].includes(status) || !['playing', 'won', 'lost'].includes(body.status) || (status === 503 && body.status !== 'won')) throw new Error('Service unavailable');
        if (!Array.isArray(body.cards) || body.cards.length !== 8 || body.cards.some(v => v !== null && (!Number.isInteger(v) || v < 0 || v > 3))) throw new Error('Invalid cards');
        if (!Array.isArray(body.matched) || !Array.isArray(body.open) || body.open.length > 2 || body.matched.length % 2 || !Number.isInteger(body.errors) || body.errors < 0 || body.errors > 3 || !Number.isInteger(body.turns) || body.turns !== body.matched.length / 2 + body.errors || !Number.isFinite(body.closeAt)) throw new Error('Invalid state');
        const visible = [...body.matched, ...body.open];
        if (new Set(visible).size !== visible.length || visible.some(i => !Number.isInteger(i) || i < 0 || i > 7) || body.cards.some((v, i) => (v !== null) !== visible.includes(i))) throw new Error('Invalid visible cards');
        if ((body.status === 'won') !== (body.matched.length === 8) || (body.status === 'lost') !== (body.errors === 3) || (body.status === 'won' && body.errors >= 3)) throw new Error('Invalid result');
        if (body.status === 'won') {
          if (!['pending', 'ready'].includes(body.reward?.status)) throw new Error('Invalid reward');
          if (body.reward.status === 'ready' && (status !== 200 || !/^TYCAP-[A-F0-9]{24}$/.test(body.reward.code || '') || body.reward.usageLimit !== 1 || body.reward.percentage !== 5 || body.reward.minimumPurchase !== 50)) throw new Error('Invalid code');
        } else if (body.reward !== null) throw new Error('Unexpected reward');
        return body;
      }
      async send(action, index) {
        if (this.busy || this.controller.signal.aborted) return;
        if (action === 'flip' && (this.failed || this.state?.status !== 'playing' || !Number.isInteger(index) || index < 0 || index > 7 || this.state.cards[index] !== null || this.state.open.length === 2)) return;
        this.busy = true;
        this.failed = false;
        const previous = this.state;
        this.render();
        this.requestController = new AbortController();
        const timeout = window.setTimeout(() => this.requestController.abort(), 45000);
        try {
          this.token = this.token || await this.identity();
          const payload = { action, visitorToken: this.token };
          if (action === 'flip') Object.assign(payload, { index, revision: this.state.revision, requestId: crypto.randomUUID() });
          const response = await fetch(this.endpoint, { method: 'POST', credentials: 'omit', cache: 'no-store', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: this.requestController.signal });
          const body = this.parse(await response.json(), response.status);
          if (this.controller.signal.aborted) return;
          this.state = body;
          const record = JSON.stringify({ version: 2, visitorToken: this.token, day: body.day, revision: body.revision });
          if (localStorage.getItem(this.storageKey) !== record) localStorage.setItem(this.storageKey, record);
          window.clearTimeout(this.turnTimer);
          if (body.open.length === 2) {
            this.turnTimer = window.setTimeout(() => {
              if (this.state !== body) return;
              this.state = { ...body, open: [], closeAt: 0, cards: body.cards.map((v, i) => body.matched.includes(i) ? v : null) };
              this.render();
            }, Math.max(0, body.closeAt - body.serverTime));
          }
        } catch {
          if (!this.controller.signal.aborted) this.failed = true;
        } finally {
          window.clearTimeout(timeout);
          this.busy = false;
          if (!this.controller.signal.aborted) {
            this.render();
            if (!this.failed && previous?.status === 'playing' && ['won', 'lost'].includes(this.state?.status)) this.root.querySelector(this.state.status === 'won' ? '[data-win-title]' : '[data-loss-title]').focus({ preventScroll: true });
            else if (!this.failed && action === 'start' && this.state?.status === 'playing') this.cards.find(card => !card.disabled)?.focus({ preventScroll: true });
          }
        }
      }
      showFailure() {
        this.failed = true;
        this.render();
      }
      render() {
        const s = this.state;
        const idle = !s || s.status === 'idle';
        const playing = s?.status === 'playing';
        const won = s?.status === 'won';
        const lost = s?.status === 'lost';
        const code = won && s.reward?.status === 'ready' ? s.reward.code : null;
        this.start.disabled = this.busy || this.failed || !idle;
        this.root.querySelector('[data-button-label]').textContent = this.busy ? this.text.loading : idle ? this.text.startLabel : playing ? this.text.playingLabel : this.text.nextDay;
        this.retry.hidden = !this.failed && !(won && !code);
        this.retry.disabled = this.busy;
        this.retry.textContent = won ? this.text.claimLabel : this.text.retryLabel;
        this.root.querySelector('[data-pairs]').textContent = String((s?.matched.length || 0) / 2);
        this.root.querySelector('[data-lives]').textContent = String(3 - (s?.errors || 0));
        this.root.querySelector('[data-result]').hidden = !won;
        this.root.querySelector('[data-loss]').hidden = !lost;
        this.root.setAttribute('aria-busy', String(this.busy));
        this.cards.forEach((card, i) => {
          const face = s?.cards[i];
          const visible = Number.isInteger(face);
          const matched = Boolean(s?.matched.includes(i));
          card.disabled = this.busy || this.failed || !playing || visible || s.open.length === 2;
          card.setAttribute('aria-disabled', String(card.disabled));
          card.classList.toggle('is-flipped', visible);
          card.classList.toggle('is-matched', matched);
          const label = matched ? this.text.matchedLabel : visible ? this.text.faceLabel : this.text.hiddenLabel;
          card.setAttribute('aria-label', label.replace('__NUMBER__', String(i + 1)).replace('__SYMBOL__', visible ? this.symbols[face].dataset.name : ''));
          if (card.dataset.visibleFace !== String(face)) {
            card.querySelector('[data-face]').replaceChildren(...(visible ? [this.symbols[face].content.cloneNode(true)] : []));
            card.dataset.visibleFace = String(face);
          }
        });
        this.status.textContent = this.failed ? this.text.serverError : this.busy ? this.text.loading : won ? this.text.win : lost ? this.text.lose : idle ? this.text.waiting : s.open.length === 2 ? this.text.miss : s.open.length === 1 ? this.text.one : this.text.ready;
        const redeem = this.root.querySelector('[data-redeem]');
        this.root.querySelector('[data-code]').textContent = code || '';
        this.root.querySelector('[data-code-box]').hidden = !code;
        this.root.querySelector('[data-reward-intro]').hidden = !code;
        this.root.querySelector('[data-reward-pending]').hidden = Boolean(code);
        redeem.hidden = !code;
        if (code) redeem.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(this.text.collectionUrl));
        else redeem.removeAttribute('href');
      }
    }
    class TycapMemory extends HTMLElement {
      connectedCallback() {
        if (this.dataset.rewardEnabled === 'true') {
          if (!this.server) {
            this.server = new TycapMemoryServer(this);
            this.server.connect();
          }
          return;
        }
        if (this.controller) return;
        this.controller = new AbortController();
        this.storageKey = 'tycap-memory-daily-v1';
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.symbols = Array.from(this.querySelectorAll('template[data-symbol]'));
        this.startButton = this.querySelector('[data-start]');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.statusNode = this.querySelector('[data-status]');
        this.result = this.querySelector('[data-result]');
        this.loss = this.querySelector('[data-loss]');
        this.pairsNode = this.querySelector('[data-pairs]');
        this.livesNode = this.querySelector('[data-lives]');
        this.renderedGame = null;
        this.busy = false;
        const signal = this.controller.signal;
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-start]')) this.act('start');
          const card = event.target.closest('[data-card]');
          if (card && this.contains(card)) this.act('flip', this.cards.indexOf(card));
        }, { signal });
        window.addEventListener('storage', (event) => {
          if (event.key === this.storageKey) this.refresh();
        }, { signal });
        window.addEventListener('focus', () => this.refresh(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, { signal });
        this.dayTimer = window.setInterval(() => {
          if (this.currentDay !== this.day()) this.refresh();
        }, 60000);
        this.refresh();
      }
      disconnectedCallback() {
        this.server?.disconnect();
        this.server = null;
        window.clearTimeout(this.turnTimer);
        window.clearInterval(this.dayTimer);
        this.controller?.abort();
        this.controller = null;
      }
      day() {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const part = (type) => parts.find((item) => item.type === type).value;
        return part('year') + '-' + part('month') + '-' + part('day');
      }
      read(day) {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return null;
        const state = JSON.parse(raw);
        if (!state || typeof state.day !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(state.day)) throw new Error('Invalid game');
        if (state.day !== day) return null;
        if (state.version !== 1 || typeof state.id !== 'string' || !Array.isArray(state.deck) || state.deck.length !== 8) throw new Error('Invalid game');
        if (![0, 1, 2, 3].every((symbol) => state.deck.filter((value) => value === symbol).length === 2)) throw new Error('Invalid deck');
        if (!Array.isArray(state.matched) || !Array.isArray(state.open) || state.open.length > 2 || state.matched.length % 2) throw new Error('Invalid cards');
        const positions = [...state.matched, ...state.open];
        if (positions.some((value) => !Number.isInteger(value) || value < 0 || value > 7) || new Set(positions).size !== positions.length) throw new Error('Invalid cards');
        if (![0, 1, 2, 3].every((symbol) => state.matched.filter((index) => state.deck[index] === symbol).length % 2 === 0)) throw new Error('Invalid pairs');
        if (!Number.isInteger(state.errors) || state.errors < 0 || state.errors > 3 || !Number.isInteger(state.turns) || state.turns < 0 || state.turns > 6) throw new Error('Invalid score');
        if (state.turns !== state.matched.length / 2 + state.errors || !Number.isFinite(state.closeAt) || state.closeAt < 0) throw new Error('Invalid score');
        const expected = state.matched.length === 8 ? 'won' : state.errors === 3 ? 'lost' : 'playing';
        if (state.status !== expected) throw new Error('Invalid outcome');
        if (state.open.length === 2 && state.deck[state.open[0]] === state.deck[state.open[1]]) throw new Error('Invalid turn');
        return state;
      }
      create(day) {
        const deck = [0, 0, 1, 1, 2, 2, 3, 3];
        for (let i = deck.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [deck[i], deck[j]] = [deck[j], deck[i]];
        }
        return { version: 1, id: crypto.randomUUID(), day, deck, matched: [], open: [], turns: 0, errors: 0, closeAt: 0, status: 'playing' };
      }
      async act(action, index) {
        if (this.busy) return;
        this.busy = true;
        try {
          const run = () => {
            const day = this.day();
            let state = this.read(day);
            let changed = false;
            let started = false;
            const previous = state?.status;
            if (state?.status === 'playing' && state.open.length === 2 && state.closeAt <= Date.now()) {
              state.open = [];
              state.closeAt = 0;
              changed = true;
            }
            if (!state && action === 'start') {
              state = this.create(day);
              changed = true;
              started = true;
            } else if (state?.status === 'playing' && action === 'flip' && state.open.length < 2 &&
              Number.isInteger(index) && index >= 0 && index < 8 &&
              !state.matched.includes(index) && !state.open.includes(index)) {
              state.open.push(index);
              changed = true;
              if (state.open.length === 2) {
                state.turns += 1;
                const [first, second] = state.open;
                if (state.deck[first] === state.deck[second]) {
                  state.matched.push(first, second);
                  state.open = [];
                  if (state.matched.length === 8) state.status = 'won';
                } else {
                  state.errors += 1;
                  state.closeAt = Date.now() + 1200;
                  if (state.errors === 3) state.status = 'lost';
                }
              }
            }
            if (changed) localStorage.setItem(this.storageKey, JSON.stringify(state));
            this.currentDay = day;
            const finished = state && previous === 'playing' && state.status !== 'playing';
            this.render(state, finished);
            if (started) this.cards[0].focus({ preventScroll: true });
          };
          if (navigator.locks?.request) await navigator.locks.request(this.storageKey, run);
          else run();
        } catch {
          this.unavailable();
        } finally {
          this.busy = false;
        }
      }
      refresh() {
        try {
          this.currentDay = this.day();
          this.render(this.read(this.currentDay));
        } catch {
          this.unavailable();
        }
      }
      label(key, index, state) {
        return this.dataset[key].replace('__NUMBER__', String(index + 1))
          .replace('__SYMBOL__', this.symbols[state.deck[index]].dataset.name);
      }
      render(state, focusResult = false) {
        window.clearTimeout(this.turnTimer);
        const playing = state?.status === 'playing';
        const won = state?.status === 'won';
        const lost = state?.status === 'lost';
        this.result.hidden = !won;
        this.loss.hidden = !lost;
        this.startButton.disabled = Boolean(state);
        this.buttonLabel.textContent = !state ? this.dataset.startLabel : playing ? this.dataset.playingLabel : this.dataset.nextDay;
        this.pairsNode.textContent = String((state?.matched.length || 0) / 2);
        this.livesNode.textContent = String(3 - (state?.errors || 0));
        this.cards.forEach((card, index) => {
          const matched = Boolean(state?.matched.includes(index));
          const flipped = Boolean(matched || state?.open.includes(index));
          card.disabled = !playing;
          card.classList.toggle('is-flipped', flipped);
          card.classList.toggle('is-matched', matched);
          card.setAttribute('aria-disabled', String(!playing || flipped));
          card.setAttribute('aria-label', state ? this.label(matched ? 'matchedLabel' : flipped ? 'faceLabel' : 'hiddenLabel', index, state) : this.dataset.hiddenLabel.replace('__NUMBER__', String(index + 1)));
          if (state && this.renderedGame !== state.id) card.querySelector('[data-face]').replaceChildren(this.symbols[state.deck[index]].content.cloneNode(true));
        });
        this.renderedGame = state?.id || null;
        this.statusNode.textContent = won ? this.dataset.win : lost ? this.dataset.lose : !state ? this.dataset.waiting :
          state.open.length === 2 ? this.dataset.miss : state.open.length === 1 ? this.dataset.one : this.dataset.ready;
        if (playing && state.open.length === 2) {
          this.turnTimer = window.setTimeout(() => this.act('settle'), Math.max(0, state.closeAt - Date.now()));
        }
        if (focusResult) this.querySelector(won ? '[data-win-title]' : '[data-loss-title]').focus({ preventScroll: true });
      }
      unavailable() {
        window.clearTimeout(this.turnTimer);
        this.startButton.disabled = true;
        this.buttonLabel.textContent = this.dataset.blockedLabel;
        this.cards.forEach((card) => { card.disabled = true; });
        this.result.hidden = true;
        this.loss.hidden = true;
        this.statusNode.textContent = this.dataset.blocked;
      }
    }
    customElements.define('tycap-memory', TycapMemory);
  }


  } catch(e) { console.error(e); }
})();
})();
